import { queryKeys } from "@/lib/queryKeys";
import createAgendaItemDataToSDKMapper from "@/mappers/agenda/createAgendaItemDataMapper";
import {
    CreateAgendaItemData,
    useSdk,
} from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useErrorToast from "../utils/useErrorToast";

const useCreateAgendaEvent = (onSuccess?: () => void) => {
    const { agendaManager } = useSdk();
    const showError = useErrorToast();
    const queryClient = useQueryClient();

    const createAgendaEvent = useMutation<
        void,
        unknown,
        { createAgendaItemData: CreateAgendaItemData }
    >({
        mutationFn: async ({ createAgendaItemData }) => {
            if (!agendaManager) {
                throw new Error("Agenda manager is not set");
            }

            const createDataToSDK =
                createAgendaItemDataToSDKMapper(createAgendaItemData);

            const created =
                await agendaManager.createAgendaItem(createDataToSDK);

            if (!created) {
                throw new Error("Agenda item creation refused by the provider");
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.agendaEvents.all(),
            });
            onSuccess?.();
        },
        onError: (error) => {
            console.error(error);
            showError({
                titleTranslationKey: "errors.agenda.create",
            });
        },
    });

    return { createAgendaEvent };
};

export default useCreateAgendaEvent;
